import React from "react";
import { Link } from "react-router-dom";

const AffiliateT_C = () => {
  return (
    <div className="Associate__container">
      <div className="box">
        <h1>
          CoinStorey Associates - coinstorey referral and affiliate marketing
          program T/C
        </h1>
        <b>
          By signing up to be an associate in the Coinstorey Associate Program
          (“PROGRAM”) you are agreeing to be bound by the following terms and
          conditions (“Terms of Service”).
        </b>
        <ul>
          <li>
            coinstorey reserves the right to update and change the Terms of
            Service from time to time without notice. Any new features that
            augment or enhance the current PROGRAM, including the release of new
            features and resources, shall be subject to the Terms of Service.
            Continued use of the PROGRAM after any such changes shall constitute
            your consent to such changes. You can review the most current
            version of the Terms of Service at any time at:{" "}
            <Link to="/terms-and-services">https://www.coinstorey.com</Link>
          </li>
          <li>
            Violation of any of the Account Terms below may result in the
            termination of your Affiliate Account and forfeiture of any
            outstanding affiliate commission payments earned during the
            violation. You agree to use the PROGRAM at your own risk.
          </li>
        </ul>

        <h2>PROGRAM Account Terms</h2>
        <ul>
          <li>
            You must provide your legal full name, a valid email address, and
            any other information requested in order to complete the signup
            process.
          </li>
          <li>
            You must be a human. Accounts registered by “bots” or other
            automated methods are not permitted.
          </li>
          <li>
            Affiliate commissions are only paid for standard licenses.
            Commissions are not paid for bulk licenses unless approved by
            coinstorey prior to order.
          </li>
          <li>
            You are responsible for all content posted and activity that occurs
            under your account (even when content is posted by others who have
            accounts under your account). One person or legal entity may not
            maintain more than one account.
          </li>
          <li>
            You may not use the PROGRAM for any illegal or unauthorized purpose.
            You must not, in the use of the Service, violate any laws in your
            jurisdiction (including but not limited to copyright laws).
          </li>
          <li>
            You may not use any coinstorey branding, trademarks, logos,
            keywords, advertising terms, or other intellectual property, whether
            in connection with the PROGRAM or otherwise, without our express
            written permission. You may not use the PROGRAM to earn money on
            your own coinstorey product accounts.
          </li>
        </ul>

        <h2>Using Links on Your Site</h2>
        <p>
          As an affiliate website of coinstorey, you may use any form of
          promotion you choose, consistent with the terms of this Agreement. You
          may use banner advertisements, button links and/or text links to our
          site (the "Links"), however, you CANNOT SPAM. Any activity by you or
          on your behalf that we determine or reasonably suspect to be the
          result of an unsolicited bulk e-mail program will result in your
          immediate termination from the PROGRAM and your forfeiting of monies
          otherwise due you hereunder. Allowable promotional links may contain
          coinstorey trade names, service marks, and/or logos for display on
          your Affiliate Site. Subject to the terms and conditions hereof, you
          are granted a limited, non-exclusive, non-transferable license to
          access and download such Links and other designated promotional
          materials for placement on your Affiliate Site for the sole and
          exclusive purpose of promoting websites owned, operated or controlled
          by coinstorey. In utilizing the Links, you agree that you will
          cooperate fully with us in order to establish and maintain such Link
          or Links. A Link may only be visually modified with our consent.
        </p>
        <h3>coinstorey IP</h3>
        <ul>
          <li>
            Your participation in the PROGRAM does not grant you any right,
            license, ownership, or other intellectual property right in any of
            coinstorey intellectual property, including our branding, logos,
            trademarks, and other intellectual property. Unauthorized use of our
            intellectual property is not permitted, whether used in your
            capacity as an affiliate or otherwise in connection with the
            PROGRAM.
          </li>
          <li>
            Paid Search Terms Affiliates shall not bid on or use coinstorey
            trademarks or misspelled keywords for the purpose of pay-per-click
            on internet search engines without prior written consent from
            coinstorey.
          </li>
          <li>
            You may not directly link to our website from any Pay Per Click ad
            or use redirects that yield the same result. Users must be directed
            to your website. It is your responsibility{" "}
            <i>
              to take all actions necessary to exclude our trademarked terms
              from your program, including, among other things, adding our
              trademarked terms as negative keywords.{" "}
            </i>
          </li>
        </ul>
        <h3>Commissions</h3>
        <p>
          <b>
            For Affiliates, payments only begin once you've earned more than $10
            in affiliate income
          </b>
          . If your affiliate account never crosses the $10 threshold, your
          commissions will not be realized or paid. We are only responsible for
          paying accounts that have crossed the $10 threshold. Any affiliate
          commissions are only paid after the license has been active for more
          than 30 days, to protect against any customer cancellations, refunds,
          or chargebacks. For example, if someone you refer purchases a
          coinstorey contest on Feb 10th, that referral becomes "active" on
          March 10th and you will be paid on the next payment period (sometime
          between April 1st - 15th, see below for Payment Schedule).
        </p>

        <h3>Receiving your Free Lifetime Coinstorey License Upgrades</h3>
        <p>
          Once you've reached Super Affiliate Status, a unique redemption code
          along with instructions, will be emailed to the email address
          associated with your affiliate account. Commission for private
          contests is only applied when the number of participants is more than
          50.
          <b>
            All commissions are recurring. You will continue to receive your
            commission for every payment that we receive each month for monthly
            licenses subject to terms of Termination below. Likewise, you will
            also receive a recurring annual commission for any annual accounts
            that you refer to.
          </b>
        </p>
        <h3>Payments</h3>
        <p>
          Commissions are paid via coinstorey payment methods. We cannot send
          checks, prepaid credit cards, or cash. You are required to have a
          coinstorey account to receive commissions. If you don't have a
          coinstorey account you can sign up for one at any time, but you will
          not be paid until you have one.
        </p>
        <h3>Payment Schedule</h3>
        <p>
          Our payment period happens whenever you want. If you are an Affiliate
          and you haven't earned $10 since your last payment, we'll pay you
          after you've crossed the $10 commission threshold. Payments are only
          made via coinstorey account.
        </p>
        <h3>Please Note:</h3>
        <p>
          {" "}
          Commissions are paid after the license has been active for more than
          30 days. For example, if someone you refer purchases a paid license on
          Feb 10th, that referral becomes "active" on March 10th and you will be
          paid.
        </p>
        <h3>Compliance with Laws</h3>
        <p>
          As a condition to your participation in the PROGRAM, you agree that
          while you are a PROGRAM participant you will comply with all laws,
          ordinances, rules, regulations, orders, licenses, permits, judgments,
          decisions or other requirements of any governmental authority that has
          jurisdiction over you, whether those laws, etc. are now in effect or
          later come into effect during the time you are a PROGRAM participant.
          Without limiting the foregoing obligation, you agree that as a
          condition of your participation in the PROGRAM you will comply with
          all applicable laws (federal, state or otherwise) that govern
          marketing email, including without limitation, the CAN-SPAM Act of
          2003 and all other anti-spam laws.
        </p>
        <h3>Termination</h3>
        <ul>
          <li>
            <em>
              Coinstorey, in its sole discretion, has the right to suspend or
              terminate your account and refuse any and all current or future
              use of the PROGRAM, or any other Coinstorey service, for any
              reason at any time. Such termination of the Service will result in
              the deactivation or deletion of your Account or your access to
              your Account, and the forfeiture and relinquishment of all
              potential or to-be-paid commissions in your Account if they were
              earned through fraudulent, illegal, or overly aggressive,
              questionable sales or marketing methods. Coinstorey reserves the
              right to refuse service to anyone for any reason at any time.
            </em>
          </li>
          <li>
            <em>
              Additionally, Coinstorey in its sole discretion has the right to
              terminate the PROGRAM at any time. If the PROGRAM is terminated,
              payment of any future commissions are terminated including
              recurring payments for prior referral purchases.
            </em>
          </li>
        </ul>
        <h3>Relationship of Parties</h3>
        <p>
          You and we are independent contractors, and nothing in this Agreement
          will create any partnership, joint venture, agency, franchise, sales
          representative, or employment relationship between the parties. You
          will have no authority to make or accept any offers or representations
          on our behalf. You will not make any statement, whether on your site
          or otherwise, that reasonably would contradict anything in this
          Section.
        </p>
        <h3>Limitations of Liability</h3>
        <p>
          We will not be liable for indirect, special, or consequential damages
          (or any loss of revenue, profits, or data) arising in connection with
          this Agreement or the PROGRAM, even if we have been advised of the
          possibility of such damages. Further, our aggregate liability arising
          with respect to this Agreement and the PROGRAM will not exceed the
          total referral fees paid or payable to you under this Agreement.
        </p>
        <h3>Disclaimers</h3>

        <p>
          We make no express or implied warranties or representations with
          respect to the PROGRAM or any products sold through the PROGRAM
          (including, without limitation, warranties of fitness,
          merchantability, noninfringement, or any implied warranties arising
          out of a course of performance, dealing, or trade usage). In addition,
          we make no representation that the operation of the Product Sites will
          be uninterrupted or error-free, and we will not be liable for the
          consequences of any interruptions or errors.
        </p>
        <h3>Independent Investigation</h3>
        <p>
          YOU ACKNOWLEDGE THAT YOU HAVE READ THIS AGREEMENT AND AGREE TO ALL ITS
          TERMS AND CONDITIONS. YOU UNDERSTAND THAT WE MAY AT ANY TIME (DIRECTLY
          OR INDIRECTLY) SOLICIT CUSTOMER REFERRALS ON TERMS THAT MAY DIFFER
          FROM THOSE CONTAINED IN THIS AGREEMENT OR OPERATE WEB SITES THAT ARE
          SIMILAR TO OR COMPETE WITH YOUR WEB SITE. YOU HAVE INDEPENDENTLY
          EVALUATED THE DESIRABILITY OF PARTICIPATING IN THE PROGRAM AND ARE NOT
          RELYING ON ANY REPRESENTATION, GUARANTEE, OR STATEMENT OTHER THAN AS
          SET FORTH IN THIS AGREEMENT.
        </p>
        <h3>Arbitration</h3>
        <p>
          Any dispute relating in any way to this Agreement (including any
          actual or alleged breach hereof), any transactions or activities under
          this Agreement or your relationship with us or any of our affiliates
          shall be submitted to Confidentiality under the Indian Arbitration &
          Conciliation Act of 1996, except that, to the extent you have in any
          manner violated or threatened to violate our intellectual property
          rights, we may seek injunctive or other appropriate relief in any
          state or federal court in india (and you consent to non-exclusive
          jurisdiction and venue in such courts) or any other court of competent
          jurisdiction. Arbitration under this agreement shall be conducted
          under the rules then prevailing of the Indian Arbitration Association.
          The arbitrator's award shall be binding and may be entered as a
          judgment in any court of competent jurisdiction. To the fullest extent
          permitted by applicable law, no arbitration under this Agreement shall
          be joined to an arbitration involving any other party subject to this
          Agreement, whether through class arbitration proceedings or otherwise.
        </p>
        <h3>Miscellaneous</h3>
        <p>
          This Agreement will be governed by the laws of the Indian
          government,without reference to rules governing choice of laws. You
          may not assign this Agreement, by operation of law or otherwise,
          without our prior written consent. Subject to that restriction, this
          Agreement will be binding on, inure to the benefit of, and be
          enforceable against the parties and their respective successors and
          assigns. Our failure to enforce your strict performance of any
          provision of this Agreement will not constitute a waiver of our right
          to subsequently enforce such provision or any other provision of this
          Agreement.
        </p>

        <p>
          The failure of Coinstorey to exercise or enforce any right or
          provision of the Terms of Service shall not constitute a waiver of
          such right or provision. The Terms of Service constitutes the entire
          agreement between you and Coinstorey and govern your use of the
          Service, superseding any prior agreements between you and Coinstorey
          (including, but not limited to, any prior versions of the Terms of
          Service).
        </p>

        <h3>Modification</h3>
        <p>
          We may modify any of the terms and conditions in this Agreement at any
          time at our sole discretion. In such an event, you will be notified by
          email. Modifications may include, but are not limited to, changes in
          the payment procedures and the PROGRAM rules. If any modification is
          unacceptable to you, your only option is to end this Agreement. Your
          continued participation in coinstorey.com's Affiliate Program
          following the posting of the change notice or new Agreement on our
          site will indicate your agreement to the changes.
        </p>
      </div>
    </div>
  );
};

export default AffiliateT_C;
